const EmbeddedComponents = require('@/vue/EmbeddedComponents');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const { PAYMENT_METHOD_CHANGED } = require('@/lib/Events/EventNames');

/**
 * @param $scope
 */
function GoCardlessCtrl(
    $scope,
) {
    const thisPaymentMethodRef = PaymentMethodRef.GOCARDLESS;

    $scope.$on('$destroy', () => {
        window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.GOCARDLESS_PAYMENT_METHOD_COMPONENT);
    });

    $scope.$on(PAYMENT_METHOD_CHANGED, function (event, newPaymentMethod) {
        const newPaymentMethodRef = newPaymentMethod?.ref;
        if (newPaymentMethodRef === thisPaymentMethodRef) {
            window.rootVueStore.commit('addActiveEmbeddedComponent', { name: EmbeddedComponents.GOCARDLESS_PAYMENT_METHOD_COMPONENT });
        } else {
            window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.GOCARDLESS_PAYMENT_METHOD_COMPONENT);
        }
    });
}

module.exports = GoCardlessCtrl;
